import { render, staticRenderFns } from "./reportDocumentAI.vue?vue&type=template&id=48b9dbaa&scoped=true"
import script from "./reportDocumentAI.vue?vue&type=script&lang=js"
export * from "./reportDocumentAI.vue?vue&type=script&lang=js"
import style0 from "./reportDocumentAI.vue?vue&type=style&index=0&id=48b9dbaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b9dbaa",
  null
  
)

export default component.exports